import { LoaderFunctionArgs } from "@remix-run/node";
import { Location, Outlet, useLocation, useLoaderData } from "@remix-run/react";

import { ToolBar } from "~/components";
import { Breadcrumbs } from "~/components/Breadcrumbs";
import { BrooklawnAssuranceModal } from "~/components/questionnaire/components";
import { getCustomerFromCookie } from "~/models";
import { getPackageSession } from "~/models/package_session.server";

export async function loader({ request }: LoaderFunctionArgs) {

    const { immediateNeedUrl } = await getPackageSession(request);

    return {
        ENV: {
            vendor: process.env.VITE_VENDOR_SLUG,
        },
        immediateNeedUrl,
        ...(await getCustomerFromCookie({ request })),
    };
}

export default function LayoutWithBreadcrumbs() {
    const { ENV, immediateNeedUrl } = useLoaderData<typeof loader>()
    const location = useLocation();
    const breadcrumbs = [{ href: "/", title: "Home" }];

    const { pathname } = location;
    LOCATION_TO_BREADCRUMB.forEach(([condition, breadcrumb]) => {
        if (typeof condition === "string") {
            if (location.pathname.startsWith(condition) && condition === "/packages/cremation") {
                breadcrumbs.push({
                    href: immediateNeedUrl || breadcrumb?.href as string,
                    title: "Cremation Choices"
                });
            }
            if (location.pathname.startsWith(condition) && condition !== "/packages/cremation") {
                breadcrumbs.push({
                    href: pathname,
                    ...breadcrumb,
                });
            }
        } else if (typeof condition === "function") {
            const isValid = condition(location);
            if (isValid) {
                breadcrumbs.push({
                    href: pathname,
                    ...(breadcrumb || isValid),
                });
            }
        }
    });

    return (
        <>
            {ENV?.vendor === "brooklawn" ? (
                <div className="p-page text-center bg-primary/10 mb-8">
                    <BrooklawnAssuranceModal />
                </div>
            ) : null}
            <section className="grid grid-cols-1 gap-4 sm:grid-cols-none sm:auto-cols-auto sm:grid-flow-col items-center page px-page py-page">
                <Breadcrumbs breadcrumbs={breadcrumbs} className="order-2 sm:order-none" />
                <ToolBar className="order-1 sm:order-none sm:justify-end" />
            </section>
            <Outlet />
        </>
    );
}

// I don't like this but couldn't think of anything better.
// best would be for individual route to define their own breadcrumb.
// maybe we moved out of folder route structure to a programmatic route structure?
const LOCATION_TO_BREADCRUMB: [
    string | ((location: Location) => boolean | { title: string; href?: string }),
    { title: string; href?: string }?,
][] = [
        [
            "/plan-for-the-future",
            {
                href: "/plan-for-the-future",
                title: "Plan for the future",
            },
        ],
        [
            "/immediate-need",
            {
                href: "/immediate-need",
                title: "Immediate Need",
            },
        ],
        [
            "/packages",
            {
                title: "Immediate Need",
                href: "/immediate-need",
            },
        ],
        [
            "/packages/cremation",
            {
                title: "Cremation choices",
                href: "/packages/cremation",
            },
        ],
        [
            ({ pathname }) => {
                if (pathname.startsWith("/map")) {
                    return true;
                } else if (pathname.endsWith("/map")) {
                    return true;
                } else {
                    return false;
                }
            },
            {
                title: "Map",
            },
        ],
        [
            ({ pathname }: Location) => {
                const parts = pathname.split("/");
                if (pathname.startsWith("/packages/cremation/")) {
                    const last = parts.at(-2);
                    if (last) {
                        return {
                            href: pathname,
                            title: last.replace("-", " "),
                        };
                    }
                }
                return false;
            },
        ],
    ];
